const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  classID:state=>state.classdata.classID,
  isCollects:state=>state.classdata.isCollects,
  classType:state=>state.classdata.classType,
  classTitle:state=>state.classdata.classTitle,
  isDuihuan:state=>state.classdata.isDuihuan,
  classNavLevel:state => state.classdata.classNavLevel,
  schoolClassNav:state=>state.classdata.schoolClassNav,
  prevRoute:state=>state.classdata.prevRoute,
  studentFileArr:state=>state.classdata.studentFileArr,
  mutilcommentArr:state=>state.classdata.mutilcommentArr,
  teacherkejianArr:state=>state.classdata.teacherkejianArr,
  isBigData:state=>state.user.isBigData
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js